import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function CTASection() {
  return <section id="pricing" className="w-full py-28 px-4 bg-brand-bg relative overflow-hidden" data-id="element-1">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-accent/5 rounded-full blur-[100px] pointer-events-none" data-id="element-2" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-3">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-4">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-8 leading-tight" data-id="element-5">
            Don't let the best years of your life be eroded by small, daily
            irritations.
          </h2>

          <p className="text-2xl text-brand-text-muted mb-12 font-light" data-id="element-6">
            Reclaim your sovereignty. Reclaim the house you earned.
          </p>

          <div className="bg-brand-card p-10 rounded-2xl border border-brand-bg-alt shadow-2xl max-w-2xl mx-auto mb-12" data-id="element-7">
            <div className="flex flex-col md:flex-row items-center justify-between mb-8" data-id="element-8">
              <div className="text-left mb-6 md:mb-0" data-id="element-9">
                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-10">
                  Home-All-Day Reset
                </h3>
                <p className="text-brand-text-muted text-sm" data-id="element-11">
                  Digital Playbook (PDF)
                </p>
              </div>
              <div className="text-right" data-id="element-12">
                <p className="text-brand-text-muted line-through text-xl mb-1" data-id="element-13">
                  $47.00
                </p>
                <span className="text-5xl font-bold text-brand-accent" data-id="element-14">
                  $6.36
                </span>
                <p className="text-sm text-green-400 font-semibold mt-1" data-id="element-15">
                  You save $40.64 (86% off)
                </p>
              </div>
            </div>

            <a href="https://www.betterbysteps.com/cart/44206224113757:1" target="_blank" rel="noopener noreferrer" className="w-full flex items-center justify-center px-8 py-5 text-xl font-bold text-white bg-brand-accent hover:bg-brand-accent-hover rounded-lg shadow-[0_0_20px_rgba(230,126,34,0.4)] hover:shadow-[0_0_40px_rgba(230,126,34,0.6)] transition-all duration-300 animate-pulse-slow whitespace-nowrap" data-id="element-16">
              Get Instant Access $6.36
            </a>

            <p className="mt-6 text-sm text-brand-text-muted italic" data-id="element-17">
              (That's less than the price of one therapy session that won't work
              anyway.)
            </p>
          </div>

          <div className="inline-flex items-center text-brand-text-muted/80 bg-brand-card/50 px-6 py-3 rounded-full border border-brand-card" data-id="element-18">
            <ShieldCheck className="w-5 h-5 mr-2 text-brand-highlight" data-id="element-19" />
            <span className="text-sm font-medium" data-id="element-20">
              100% Secure Checkout • Instant Digital Delivery
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}